module.exports = __webpack_public_path__ + "static/media/profile-pic-2.2866513f.jpg";